import { FC } from 'react';
import * as React from 'react';
import { ApplicationWrapperResponsive } from './ApplicationWrapper';
import { ApplicationWrapperProps } from './ApplicationWrapper.types';

export const ApplicationWrapperMobile: FC<ApplicationWrapperProps> = (props) => <ApplicationWrapperResponsive {...props} isMobile />;
